import { takeEvery } from 'redux-saga/effects';

import * as authActionTypes from 'store/modules/auth';

import { cancelSignIn } from './utils';

export default function* listenCancelSignIn() {
  yield takeEvery(authActionTypes.cancelSignInActions, cancelSignIn);
}
